import React from 'react';
import CommonFields from './CommonFields';

const Image1Type = ({name, form, previousPages}) => <CommonFields name={name} form={form} required={true} previousPages={previousPages} />;

export default Image1Type;
